export const sortCards = (array, sortArray) => {
  return [...array].sort(
    (a, b) => sortArray.indexOf(a.id) - sortArray.indexOf(b.id)
  );
};
